import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <footer>
                ©2019 ISSC, Designed by <a href="http://forrest-keller.web.app">Forrest Keller</a>
            </footer>
        )
    }
}
